import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useStoreActions from './actions';
import useCommonGetters from '../common-getters';
import { UserAvatar, IUsersState, User } from './models';

export const useUsersStore = defineStore('users', () => {
  const state = ref(<IUsersState>{
    users: [],
    allUsersLite: [],
    rightSideDrawerUsers: [],
    userOverview: {} as User,
    userProperties: {} as User,
    availableUserGroups: [],
    availableProfiles: [],
    departmentsDropDown: [],
    plantsDropDown: [],
    usergroups: [],
    businessUnitsDropDown: [],
    userAvatar: {} as UserAvatar,
    isCreateUserDialogVisible: false,
  });

  return {
    ...toRefs(state.value),
    ...useCommonGetters<IUsersState>(state),
    ...useStoreActions(state),
  };
});
